import { EnumSchema } from '../metadata-schema';

export const Vakkengroep: EnumSchema = {
	"type": "string",
	"title": "Vakkengroep",
	"enum": [
		"Nederlands",
		"Engels, Frans, Duits",
		"Aardrijkskunde en Geschiedenis",
		"Economische vakken",
		"Wis-, Natuur-, Scheikunde en Biologie",
		"Grieks en Latijn",
		"Overige vakken"
	]
};
